// Vendor imports
const Immutable = require('immutable')
const { createSelector } = require('reselect')
const _ = require('lodash')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const IntoFeedItem = require('./feed-item')

function onContentCardClick() {
  businessEvents.trackSegment('into-content-card-click')
}

function renderIntoItemCard({ id, item }) {
  return (
    tag(IntoFeedItem, {
      key: id,
      href: item ? `/!${item.article['url_hash']}` : null,
      item,
      onClick: onContentCardClick
    })
  )
}

function createIntoItemCardFeedItem(item, index) {
  const article = _.get(item, 'article')
  if (!article) {
    return {
      type: null
    }
  }
  return {
    id: `into-item-card:${index}`,
    item,
    type: 'render',
    render: renderIntoItemCard
  }
}

const getItemCards = createSelector(
  [
    state => state.feed.items
  ],
  (items) => {
    let emptyItemsCount = 0
    if (items.size < 12) {
      emptyItemsCount = 12 - items.size
    }
    return Immutable.List(
      [...items, ...new Array(emptyItemsCount)].map((item, index) => createIntoItemCardFeedItem(item, index))
    )
  }
)

module.exports = {
  getItemCards
}
